import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import i18n from '@/utils/i18n';
import Checkbox from '../../../components/Checkbox';
import {
  CheckBoxLabel,
  CheckBoxLabelContainer,
} from '../../../components/Checkbox/pickpackCheckbox';

interface SetCheckoutLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (isUnlimited: boolean, isDefault: boolean, limit: number) => void;
}

export const SetCheckoutLimitModal: React.FC<SetCheckoutLimitModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [checkoutLimit, setCheckoutLimit] = useState(0);
  const [isUnlimited, setIsUnlimited] = useState(false);
  const [isDefault, setIsDefault] = useState(false);

  const handleSubmit = () => {
    onSubmit(isUnlimited, isDefault, checkoutLimit);
    onClose();
  };

  const footer = (
    <div>
      <Button onClick={handleSubmit} color="danger">
        Set checkout limit to{' '}
        {isUnlimited ? 'unlimited' : isDefault ? 'default' : checkoutLimit}
      </Button>
      <Button onClick={onClose} color="secondary">
        Cancel
      </Button>
    </div>
  );

  return (
    <Dialog
      header="Set checkout limit"
      visible={isOpen}
      onHide={onClose}
      style={{ minWidth: '50vw' }}
      footer={footer}
    >
      <Form>
        <FormGroup>
          <Label className="me-2">New checkout limit: </Label>
          <Input
            id="newCheckoutLimit"
            name="newCheckoutLimit"
            type="number"
            value={checkoutLimit || 0}
            disabled={isUnlimited || isDefault}
            onChange={(e: any) => {
              const newCheckoutLimit = parseInt(e.target.value, 10);
              setCheckoutLimit(
                Number.isNaN(newCheckoutLimit) ? 0 : newCheckoutLimit,
              );
            }}
          />
          <CheckBoxLabelContainer
            style={{ marginTop: '1.5em' }}
            onClick={() => {
              setIsUnlimited(!isUnlimited);
              setIsDefault(false);
            }}
          >
            <Checkbox checked={isUnlimited} />
            <CheckBoxLabel>{i18n.t('Common:unlimited')}</CheckBoxLabel>
          </CheckBoxLabelContainer>
          <CheckBoxLabelContainer
            style={{ marginTop: '1.5em' }}
            onClick={() => {
              setIsUnlimited(false);
              setIsDefault(!isDefault);
            }}
          >
            <Checkbox checked={isDefault} />
            <CheckBoxLabel>{i18n.t('Common:default')}</CheckBoxLabel>
          </CheckBoxLabelContainer>
        </FormGroup>
      </Form>
    </Dialog>
  );
};
